export default __webpack_public_path__ + "static/media/activity-coding-hero.e885444e.png";